import Vue from 'vue';
import LiveSelect from './LiveSelect.vue';

const LiveSelectConstructor = Vue.extend(LiveSelect);

function openLiveSelect({ webHandler, clientHandler }) {
  const instance = new LiveSelectConstructor();
  instance.openByWeb = () => {
    webHandler && webHandler();
    instance.$destroy();
    document.body.removeChild(instance.$el);
  };
  instance.openByClient = () => {
    clientHandler && clientHandler();
    instance.$destroy();
    document.body.removeChild(instance.$el);
  };
  instance.$mount();
  document.body.appendChild(instance.$el);
}

Vue.prototype.$courseExtension = { openLiveSelect };
